import { render, staticRenderFns } from "./SalesScoreDiscountList.vue?vue&type=template&id=31feae9e&scoped=true&"
import script from "./SalesScoreDiscountList.vue?vue&type=script&lang=js&"
export * from "./SalesScoreDiscountList.vue?vue&type=script&lang=js&"
import style0 from "./SalesScoreDiscountList.vue?vue&type=style&index=0&id=31feae9e&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "31feae9e",
  null
  
)

export default component.exports